import React from 'react';
import {
  Image,
  ImageStyle,
  Pressable,
  StyleProp,
  Text,
  TextStyle,
  View,
  ViewStyle,
} from 'react-native';

import { KHButton, KHColors, KHIcon } from '../khui';

const styles = {
  background: {
    borderRadius: 16,
    paddingVertical: 16,
    paddingHorizontal: 18,
    marginBottom: 12,
    overflow: 'hidden',
  } as ViewStyle,
  row: {
    flexDirection: 'row',
    justifyContent: 'space-around',
    alignItems: 'flex-end',
    height: 120,
  } as ViewStyle,
  image: {
    width: 160,
    height: 120,
    resizeMode: 'contain',
  } as ImageStyle,
  responsiveSpring: {
    flex: 1,
    maxWidth: 200,
    height: 20,
  } as ViewStyle,
  button: {
    position: 'absolute',
    right: 0,
    borderRadius: 24,
    height: 50,
    backgroundColor: KHColors.backgroundContrast,
    marginBottom: 16,
  } as ViewStyle,
  buttonLabel: {
    marginLeft: 18,
    marginRight: 10,
  } as ViewStyle,
  buttonLabelView: {
    flexDirection: 'row',
  } as ViewStyle,
  buttonLabelText: {
    color: KHColors.iconPrimary,
    lineHeight: 26,
    fontSize: 15,
    fontWeight: 'bold',
    marginRight: 10,
  } as TextStyle,
  description: {
    marginTop: 8,
    color: KHColors.textContrast,
    fontSize: 13,
  } as TextStyle,
};

interface Props {
  buttonLabel: string;
  onPress: () => void;
  backgroundColor: string;
  buttonStyle?: StyleProp<ViewStyle>;
  imageSource?: string;
  description?: string;
  testID?: string;
}

export default function AppointmentOptionItem({
  buttonLabel,
  onPress,
  backgroundColor,
  buttonStyle,
  imageSource,
  description,
  testID,
}: Props): JSX.Element | null {
  return (
    <Pressable onPress={onPress} style={[styles.background, { backgroundColor }]} testID={testID}>
      <View style={styles.row}>
        <Image style={styles.image} source={{ uri: imageSource }} />
        <View style={styles.responsiveSpring} />
        <KHButton
          onPress={onPress}
          style={[styles.button, buttonStyle]}
          labelStyle={styles.buttonLabel}
        >
          <View style={styles.buttonLabelView}>
            <Text style={styles.buttonLabelText}>{buttonLabel}</Text>
            <KHIcon source="chevron-right" color={KHColors.iconPrimary} size={24} />
          </View>
        </KHButton>
      </View>
      {description != null && <Text style={styles.description}>{description}</Text>}
    </Pressable>
  );
}
